import '../lib/jquery.min.js';
import '../lib/jquery.dotdotdot.min.js';
import '../lib/greensock/TweenLite.min.js';
import '../lib/greensock/TimelineLite.min.js';
import '../lib/greensock/easing/EasePack.min.js';
import '../lib/greensock/plugins/CSSPlugin.min.js';
import '../lib/greensock/plugins/ScrollToPlugin.min.js';
import '../lib/greensock/utils/SplitText.min.js';
import '../lib/jquery.imageframe.js';
import '../lib/jquery.videoframe.js';
import '../lib/js.cookie.js';
import '../global/main.js';

import AnimatedPage from '../pages/AnimatedPage';
import Home from '../pages/Home';
import Agence from '../pages/Agence';
import Projets from '../pages/Projets';
import Projet from '../pages/Projet';
import Error404 from '../pages/Error404';




$(document).ready(function(){
    if($('.slider').length){
        new Home();
    }
    else if($('.PageLayout--agence').length){
        new Agence();
    }
    else if($('.PageLayout--projets').length){
        new Projets();
    }
    else if($('.PageLayout--projet').length){
        new Projet();
    }
    else if($('.error404').length){
        new Error404();
    }

});
